import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

const FONT_ICON_STYLES = {
	fontSize: '4rem',
	marginBottom: '-1rem',
	marginLeft: '-1rem',
	marginTop: '-1rem',
	marginRight: '-0.5rem'
};

export default (theme: APTheme) => createStyles({
	"@keyframes onloadup": {
		"0%": {
			opacity: 0,
		},
		"100%": {
			opacity: 1,
		}
	},
	accountContainer: {
		background: '#F5F5F5',
		color: '#4a4a4a',
		fontSize: 16,
		letterSpacing: '-0.5px',
		height: '100%',
		padding: '34px 35px',
		animationName: `$onloadup`,
		animationDuration: '0.3s',
		animationFillMode: 'both',
		animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
		'@media(max-width: 1200px)': {
			paddingLeft: 110,
		},
		'@media(max-width: 768px)': {
			padding: 30,
		},
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	emptyData: {
		boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
		backgroundColor: '#fff',
		textAlign: 'center',
		padding: '6em 1em',
		'& h3': {
			marginBottom: 10
		},
		'& p': {
			margin: 0
		}
	},
	accountContainerContent: {
		maxWidth: '1110px',
		position: 'relative',
		height: '100%'
	},
	accountChart: {
		background: '#FFF',
		margin: '20px 0',
		padding: 20
	},
	accountSectionSummary: {
		padding: '15px 1.875em',
		'@media(max-width: 1200px)': {
			padding: '1.25em',
		}
	},
	accountSection: {
		padding: 30,
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	accountTable: {
		background: '#FFF'
	},
	downloadButtons: {
		boxShadow: 'none !important',
	},
	dropDownMenu: {
		marginLeft: 30,
		'@media(max-width: 480px)': {
			marginLeft: 0,
		},
	},
	filterContainer: {
		display: 'flex',
		'@media(max-width: 1024px)': {
			flexDirection: 'column-reverse'
		},
		'& .MuiButtonGroup-root': {
			'& button': {
				height: '45px'
			}
		}
	},
	filterRight: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		justifyContent: 'flex-end',
		justifySelf: 'flex-end',
		marginBottom: '30px',
		'@media(max-width: 1024px)': {
			justifyContent: 'flex-start'
		},
		'@media(max-width: 480px)': {
			display: 'block',
			marginBottom: 10,
			'& > div': {
				width: '100%',
			},
		},
	},
	headlines: {
		display: 'flex',
		margin: '15px 0'
	},
	iconDown: {
		...FONT_ICON_STYLES,
		color: '#FF5F5F'
	},
	iconUp: {
		...FONT_ICON_STYLES,
		color: '#9BE169'
	},
	miniStatLabel: {
		fontSize: '1.2rem',
		marginLeft: '0.5rem'
	},
	miniStatSummary: {

	},
	miniStatValue: {

	},
	payment: {
		alignItems: 'center',
		color: '#A4A4A4',
		display: 'flex',
		fontSize: '1.7rem',
		fontWeight: 400
	},
	paymentAmount: {
		color: '#4A4A4A',
		fontSize: '3.2rem',
		fontWeight: 900,
		marginRight: 10
	},
	paymentDate: {
		color: '#4A4A4A',
		fontWeight: 500,
		marginLeft: '1rem'
	},
	paymentInfo: {

	},
	statistics: {
		display: 'flex',
		justifyContent: 'space-between',
		'@media(max-width: 990px)': {
			display: 'block',
		}
	},
	statementSelection: {
		width: 200
	},
	graphLoader: {
		height: 371,
		position: 'relative'
	},
	graphLoaderSpinner: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		margin: 'auto',
	},
});
